const trustCategories = [
  'Logistica urbana',
  'Delivery multi-città',
  'Noleggio operativo',
  'Field service',
  'Operations desk',
  'Flotte miste',
];

const stats = [
  { value: '1 sec', label: 'frequenza dati OBD' },
  { value: '-18%', label: 'costi flotta medi' },
  { value: '100%', label: 'scadenze sotto controllo' },
];

export default function TrustSparkles() {
  return (
    <div
      id="trust"
      className="relative overflow-hidden rounded-3xl border border-default/60 bg-default/40 px-6 py-12"
    >
      <div className="relative z-10 text-center">
        <span className="rounded-full border border-default bg-muted px-3 py-1 text-eyebrow text-link">
          Scelto dai team operativi
        </span>
        <h2 className="mx-auto mt-6 max-w-3xl text-balance text-4xl font-semibold tracking-tight text-strong md:text-5xl">
          Le flotte che non si possono permettere di fermarsi scelgono MovoFleet
        </h2>

        <div aria-hidden className="relative mx-auto mt-10 h-px w-2/3 max-w-md">
          <div className="absolute inset-x-0 top-0 h-px bg-linear-to-r from-transparent via-accent-blue to-transparent" />
          <div className="absolute inset-x-10 top-0 h-px bg-linear-to-r from-transparent via-accent-blue/40 to-transparent blur-xs" />
        </div>

        <div className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-3">
          {stats.map((s) => (
            <div key={s.label}>
              <div className="text-4xl font-semibold tabular-nums text-brand md:text-5xl">
                {s.value}
              </div>
              <div className="mt-2 text-sm text-subtle">{s.label}</div>
            </div>
          ))}
        </div>

        <div className="mt-14 flex flex-wrap items-center justify-center gap-3">
          {trustCategories.map((category) => (
            <span
              key={category}
              className="rounded-full border border-default bg-default px-4 py-2 text-caption font-medium text-muted shadow-resting"
            >
              {category}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
